import classnames from 'classnames';
import { bool, func, number, string } from 'prop-types';
import { createElement } from 'react';

import Button from '../button/Button';
import ArrowForward from '../icon/ArrowForward';
import BetHeaderButton from './BetHeaderButton';

const MenuButton = ({
  active,
  label,
  level = 0,
  hasActiveReduction,
  onClick,
  buttonRef,
}) =>
  createElement(
    level === 0 ? BetHeaderButton : Button,
    {
      className: classnames({
        'submenu-button': level > 0,
        'has-active-reduction': hasActiveReduction,
      }),
      onClick,
      buttonRef,
      active: level === 0 ? active : undefined,
    },
    level === 0 ? (
      <span className="title">{label}</span>
    ) : (
      <div className="submenu-button__inner">
        <span className="title">{label}</span>
        <span className="icon-wrapper--expand">
          <ArrowForward />
        </span>
      </div>
    ),
  );

MenuButton.propTypes = {
  active: bool.isRequired,
  label: string.isRequired,
  level: number,
  hasActiveReduction: bool,
  onClick: func.isRequired,
  buttonRef: func,
};

export default MenuButton;
